import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, UrlTree, Router } from "@angular/router";
import { select, Store } from "@ngrx/store";
import { Observable, of } from "rxjs";
import { catchError, map, take } from "rxjs/operators";
import { ReturnOrderService } from "../services/return-order/return-order.service";
import { clientConfig } from '../constant/app.constant';

@Injectable({
  providedIn: "root",
})
export class CancelOriginalReturnRouteGuard  {
  constructor(private router: Router, private returnOrderService: ReturnOrderService, private store: Store<AppState>) {}

  canActivate(
    next: ActivatedRouteSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const current = next.routeConfig.path;
    console.log("current :>> ", current);

    let orderData: any;
    this.store
      .pipe(select("orderData"))
      .pipe(take(1))
      .subscribe((o) => {
        orderData = o;
      });

    if (orderData.hasCarrierCancelled &&
      orderData.hasCarrierCancelled.toLowerCase() === "true" &&
      this.returnOrderService.originalReturnCancelled === false) {
      return this.returnOrderService.cancelOrder(clientConfig.MERCHANT_ID, clientConfig.EXTERNAL_ID, "Return").pipe(
        map((res: any) => {
          if (res.success) {
            this.returnOrderService.originalReturnCancelled = true;
            return true;
          }

          return false;
        }),
        catchError(() => {
          return of(false);
        })
      );
    }
    return true;
  }
}
